import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CollectionTabs = ({ collections, activeTab, onTabChange, onQuickAdd }) => {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  const displayedCollections = showAll ? collections : collections?.slice(0, 6);

  const handleEditCollection = (e, collection) => {
    e?.stopPropagation();
    navigate(`/collection-detail?id=${collection?.id}`);
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-card-foreground">Collection Categories</h2>
        <div className="flex items-center space-x-3">
          <button
            onClick={onQuickAdd}
            className="flex items-center space-x-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-200 premium-hover"
          >
            <Icon name="Plus" size={16} />
            <span className="hidden sm:inline">Add Collection</span>
          </button>
          {collections?.length > 6 && (
            <button
              onClick={() => setShowAll(!showAll)}
              className="flex items-center space-x-2 px-4 py-2 bg-muted text-muted-foreground rounded-lg hover:bg-muted/80 transition-colors duration-200"
            >
              <span>{showAll ? 'Show Less' : 'Show All'}</span>
              <Icon name={showAll ? "ChevronUp" : "ChevronDown"} size={16} />
            </button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {displayedCollections?.map((collection) => (
          <button
            key={collection?.id}
            onClick={() => onTabChange(collection?.id)}
            className={`p-4 rounded-lg border transition-all duration-300 premium-hover text-left relative group ${
              activeTab === collection?.id
                ? 'bg-primary/10 border-primary/20 text-primary' :'bg-card border-border text-card-foreground hover:bg-muted/50'
            }`}
          >
            {/* Edit Button */}
            <button
              onClick={(e) => handleEditCollection(e, collection)}
              className="absolute top-2 right-2 w-7 h-7 rounded-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-muted hover:bg-primary hover:text-primary-foreground text-muted-foreground z-10"
              title={`Edit ${collection?.name}`}
            >
              <Icon name="Pencil" size={13} />
            </button>

            <div className="flex items-center space-x-3 mb-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                activeTab === collection?.id ? 'bg-primary/20' : 'bg-muted/50'
              }`}>
                <Icon 
                  name={collection?.icon} 
                  size={20} 
                  className={activeTab === collection?.id ? 'text-primary' : 'text-muted-foreground'} 
                />
              </div>
              <div className="flex-1 min-w-0 pr-6">
                <h3 className="font-medium truncate">{collection?.name}</h3>
                <p className="text-sm text-muted-foreground">{collection?.items} items</p>
              </div>
            </div>
            
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">Value</span>
                <span className="text-sm font-medium">${collection?.value?.toLocaleString()}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">Change</span>
                <span className={`text-sm font-medium flex items-center ${
                  collection?.change >= 0 ? 'text-success' : 'text-destructive'
                }`}>
                  <Icon 
                    name={collection?.change >= 0 ? "TrendingUp" : "TrendingDown"} 
                    size={12} 
                    className="mr-1" 
                  />
                  {collection?.change >= 0 ? '+' : ''}{collection?.change}%
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CollectionTabs;